import {http} from './config';

export default {
    create: type => http.post('api/v1/formas-pagamentos', type),

    index: (page = 1) => http.get(`api/v1/formas-pagamentos?page=${page}`),

    update: type => http.put(`api/v1/formas-pagamentos/${type.id}`, type),

    delete: id => http.delete(`api/v1/formas-pagamentos/${id}`),

    list: config => http.get('api/v1/formas-pagamentos/listar', config ?? {}),
};
